'use client';
import { useFriendlyViewPort } from '../../../../hooks/useFriendlyViewPort';
import LargeLayout from '../../../../containers/LargeLayout';
import { useViewportSizeTracking } from '../../../../hooks/useViewportSizeTracking';
import PageElement from '../../../../components/PageElements/PageElement';
import allProjectsVal from './page.val';
import projectSummaryVal from '../../../../settings/projectSummary.val';
import { useVal, useValRoute } from '../../../../val/val.client';
import { notFound } from 'next/navigation';
import PageIngress from '../../../../components/PageIngress/PageIngress';
import Body from '../../../../components/Body/Body';
import ContactSales from '../../../../components/ContactSales/ContactSales';
import PageHeader from '../../../../components/PageHeader/PageHeader';
import type { ValEncodedString } from '@valbuild/next';

const Project = (props: { params: Promise<{ slug: string }> }) => {
  useFriendlyViewPort();
  useViewportSizeTracking();
  const project = useValRoute(allProjectsVal, props.params);
  const projectSummary = useVal(projectSummaryVal);
  if (!project) {
    return notFound();
  }
  const { hero, content } = project;

  const projectSummaryComplete = [
    {
      label: projectSummary.projectSummaryLabels.client,
      value: hero.projectSummary.client,
    },
    {
      label: projectSummary.projectSummaryLabels.period,
      value: hero.projectSummary.period,
    },
    {
      label: projectSummary.projectSummaryLabels.contributions,
      value: hero.projectSummary.contributions,
    },
    {
      label: projectSummary.projectSummaryLabels.services,
      value: hero.projectSummary.services?.join(', ') as ValEncodedString,
    },
  ].filter((item) => !!item.value);

  return (
    <>
      <div>
        <LargeLayout>
          <PageHeader
            header={hero.title}
            subheader={hero.shortDescription}
            image={hero.image}
          />

          <PageIngress
            text={hero.projectSummary.description}
            rightContent={
              <div className="flex flex-col gap-16 tablet:gap-32 tablet:pl-[50%]">
                {projectSummaryComplete.map((item, i) => {
                  return (
                    <div key={i} className="flex flex-col gap-4">
                      <h3 className="text-blank-yellow-tint-70">
                        {item.label}
                      </h3>
                      <Body className="text-base">{item.value}</Body>
                    </div>
                  );
                })}
              </div>
            }
          />

          {content.map((element, i) => (
            <PageElement key={i} element={element} />
          ))}
          <ContactSales />
        </LargeLayout>
      </div>
    </>
  );
};

export default Project;
